module.exports = __webpack_public_path__ + "img/mimg02.11d67e1d.jpg";